import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import logger from "@insite/client-framework/Logger";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";
import { LockStepReceivableModel } from "@tFissco/ApiModels";
import {
    LockStepReceivableApiParameter,
    submitLockStepReceivable as submitLockStepReceivableApi
} from "@tFissco/Services/LockStepReceivableService";

type LockStepReceivableParameter = {
    customerNumber: string;
    method: string;
    onSuccess?: () => void;
    onError?: (error: string, statusCode?: number) => void;
} & HasOnSuccess;

type HandlerType = ApiHandlerDiscreteParameter<LockStepReceivableParameter, LockStepReceivableApiParameter>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const SendDataToApi: HandlerType = async props => {
    try {
        const result = await submitLockStepReceivableApi(props.apiParameter);
    } catch (error) {
        logger.warn(`Failed to send data to API: ${error}`);
        return false;
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.();
};

export const chain = [PopulateApiParameter, SendDataToApi, ExecuteOnSuccessCallback];

const submitLockStepReceivable = createHandlerChainRunner(chain, "SubmitLockStepReceivable");
export default submitLockStepReceivable;
